module.exports = __webpack_public_path__ + "static/media/IG.ad4a57c1.svg";